<template>
    <div>
        <v-custom-select
                v-model="UserSelected"
                :options="CustomerUsersOptions" 
                option-name="Email" 
                option-value="Email" 
                name="users" 
                search-label="Email" 
                track-by="Email"
                :fluid="true" 
                :multiple="true">
            <slot slot="label"><slot name="label"></slot></slot>
            <slot slot="action">
                <v-add-user @userAdded="addNewUser" 
                    :customerKey="customerKey"
                    :roleOptions="[
                        { value: 'Klant', content: $t('users.roles.administrator')},
                        { value: 'MarketingKlant', content: 'Marketing'},
                        { value: 'PersoneelKlant', content: $t('users.roles.personnel')}
                    ]">
                </v-add-user>
            </slot>
        </v-custom-select>
        <v-error v-if="error">
            <slot name="error">{{ error }}</slot>
        </v-error>
    </div>
</template>

<script>
    import Vue from 'vue'
    import VCustomSelect from '@/components/form/CustomSelect'
    import VAddUser from '@/components/form/userSelect/AddUser'
    import VError from './../Error.vue'
    import _isEmpty from 'lodash/isEmpty'

    // Store
    import {mapState} from 'vuex'
    import {mapGetters} from 'vuex'

    export default {
        props: {
            value: { type: Array},
            error: String,
            addUser: { type: Boolean, default: true },
            customerKey: { type: Number, default: 0 }
        },
        components: {
            VCustomSelect,
            VAddUser,
            VError
        },
        watch: {
            customerKey() {
                this.fetchData();                
            }
        },
        computed: {
            ...mapGetters({
                CustomerUsersOptions: 'CustomerUsersOptions'
            }),
            UserSelected: {
                get() {
                    return this.value;
                },
                set(value){
                    this.$emit('input', value);
                }
            }
        },
        methods: {            
            addNewUser(newUser) {
                this.CustomerUsersOptions.push(newUser); //add new user to options
                this.value.push(newUser); //add new user to selected options
            },
            fetchData(){
                this.$store.dispatch('getCustomerUsersOptions', this.customerKey); //load data in CustomersUsersOptions
            }         
        }
    }
</script>

<style lang="scss" scoped>

    @import "~@/assets/scss/private";

</style>


// WEBPACK FOOTER //
// src/components/form/userSelect/UserSelect.vue